import React, { Component } from 'react';
import Helmet from 'react-helmet';
import dayjs from 'dayjs';
import Axios from 'axios';
import './index.scss';
import SheltertMap from '../EvacuationSheltertMap';
// import EvacuationChartMap from '../EvacuationChartMap';

// Utils
import CustomSelect from '../../utils/CustomSelect';
import LoadingDots from '../../utils/LoadingDots';
import LimitMask from '../../utils/LimitMask';
import chartCapture from '../../utils/Shared/chartCapture';

// Container
import { apiHost } from '../../utils/Shared/constant';
import { downloadTrigger, loginRedirect } from '../../utils/Shared/methods';
import ShelterChartTable from '../ShelterChartTable';
import CustomDropdown from '../../utils/CustomDropdown';
import gaTracking from '../../utils/Shared/gaTracking';

// rsuite
import { TagPicker, Tag, Toggle, Animation } from 'rsuite';
import { Link } from 'react-router-dom';


class EvacuationShelter extends Component {
	constructor(params) {
		super(params);
		this.state = {
			currentShelterIndex: null,
			updateDate: null,
			isMemberLogin: false,
			isAuthMemberLogin: false,
			isDataLoading: false,
			isVillageShow: false,
			selectedCounty: null,
			selectedTown: null,
			selectedVillage: null,
			sheltersData: null,
			disasterList: null,
			shelterFeatureList: null,
			disaster: null,
			feature: null,
			feature2: null,
			shelterCountMin: null,
			shelterCountMax: null,
			csvData: null,
			keyword: '',
			shelterMapData: null,
			isEditMode: false,
			// New
			disasterListTagPicker: null,
			selectedDisasterList: null,
			// New end
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.props.onLoadHeaderColor('PINK');
		this.props.onLoadHeaderTheme('DARK');
		this.props.onLoadShowLanguage('HIDE');
		const breadcrumb = [
			{ name: '首頁', href: '/' },
			{ name: '撤離與收容評估', href: '/evaluation/evacuation' },
			{ name: '收容所資訊查詢', href: '/evaluation/evacuation/shelter' },
		]
		this.props.onLoadShowBreadcrumb('SHOW', breadcrumb);

		this.checkAuthMemberLogin();
		this.getAvailableCounty();
		this.getUpdateDate();
		this.checkMemberLogin();
		this.getDisaster();
		this.getShelterFeature();
	}

	checkAuthMemberLogin = () => {
		Axios.post(`${apiHost}/api/Account/IsAuthMember`, {}
			, {
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer ' + window.localStorage.getItem('user-token'),
				}
			}
		).then(result => {
			this.setState({ isAuthMemberLogin: result.data.Result });
		}).catch((error) => {
			this.setState({ isAuthMemberLogin: false });
		})
	}

	checkMemberLogin = () => {
		if (window.localStorage.getItem('user-token')) {
			this.setState({ isMemberLogin: true });
		}
	}
	getAvailableCounty = () => {
		Axios.get(`${apiHost}/api/Setting/GetCountiesTownsVillagesData`)
			.then(result => {
				this.setState({ countiesTownsVillagesData: result.data });
			})
	}
	getUpdateDate = () => {
		Axios.get(`${apiHost}/api/Setting/GetShelterUpdateDatetime`)
			.then(res => {
				this.setState({ updateDate: res.data.update });
			})
	}

	getDisaster = () => {
		Axios.get(`${apiHost}/api/ShelterInfo/GetAdvancedTerm`, { params: { category: '災別' } })
			.then(result => {
				this.setState({ disasterList: result.data }, ()=>{
					// New
					this.handleDisasterListTransform();
				});
			})
	}

	// New
	// disasterList資料轉換
	handleDisasterListTransform = () => {
		const { disasterList } = this.state;
		const data = disasterList.map(item=>{
			return { 
				label: item.Name, 
				value: item.Name 
			}
		})
		this.setState({
			disasterListTagPicker: data
		}, ()=>{
			console.log(this.state.disasterListTagPicker);
		})
	}

	// 災別Change
	handleDisasterListChange = (value) => {
		this.setState({ 
			selectedDisasterList: value,
		}, ()=>{
			console.log('selectedDisasterList',this.state.selectedDisasterList)
		})		
	}

	// 災別全選
	handleDisasterListAll = () => {
		const { disasterList} = this.state;
		let selectedDisasterList = disasterList.map(item=>item.Name)
		this.setState({ 
			selectedDisasterList,  
		}, ()=>{
			console.log('selectedDisasterList',this.state.selectedDisasterList)
		});
	}
	// New end

	getShelterFeature = () => {
		Axios.get(`${apiHost}/api/ShelterInfo/GetAdvancedTerm`, { params: { category: '空間特性' } })
			.then(result => {
				this.setState({ shelterFeatureList: result.data });
			})
	}

	handleCountyDistrictPickSelected = selectedCode => {
		const { countiesTownsVillagesData } = this.state;
		const selectedDistrict = countiesTownsVillagesData.counties.find(({ code }) => code === selectedCode);		
		this.setState({ selectedCounty: selectedDistrict, selectedTown: null, selectedVillage: null });
	}
	handleTownDistrictPickSelected = selectedCode => {
		const { selectedCounty } = this.state;
		if (selectedCounty === null) return;
		const selectedDistrict = selectedCounty ? selectedCounty.towns.find(({ code }) => code === selectedCode) : null;
		this.setState({ selectedTown: selectedDistrict, selectedVillage: null, isVillageShow: false });
	}
	handleVillageDistrictPickSelected = selectedCode => {
		const { selectedTown, selectedCounty } = this.state;
		if (selectedCounty === null) return;
		if (selectedTown === null) return;
		const selectedDistrict = selectedTown ? selectedTown.villages.find(({ code }) => code === selectedCode) : null;
		this.setState({ selectedVillage: selectedDistrict, });
	}
	handleGetShelterLocate = () => {
		const { selectedCounty, selectedTown, selectedVillage, isMemberLogin, isVillageShow, selectedDisasterList, feature, feature2, shelterCountMin, shelterCountMax, keyword } = this.state;		
		const countyCode = selectedCounty ? selectedCounty.code : 'all';
		const county = selectedCounty ? selectedCounty.county : '';
		const townCode = selectedTown ? selectedTown.code : 'all';
		const town = selectedTown ? selectedTown.town : '';
		const villageCode = selectedVillage ? selectedVillage.code : 'all';
		const village = selectedVillage ? selectedVillage.village : '';
		this.setState({ isDataLoading: true, isEditMode: true, activeIndex: 0 });
		const apiUrl = (selectedVillage) ?
			`${apiHost}/api/ShelterInfo/GetShelterInfoVillage` :
			`${apiHost}/api/ShelterInfo/GetShelterInfoTown`;
	
		let params = {};
		params.county = countyCode;
		params.town = townCode;
		if (selectedVillage) {
			params.village = villageCode;
		}
		params.login = isMemberLogin;
		//進階查詢		
		params.disasters = selectedDisasterList?selectedDisasterList:[];
		params.feature = feature ? feature.Name : 'all';
		params.feature2 = feature2 ? feature2 : 'all';
		params.shelterCountMin = shelterCountMin ? shelterCountMin : -1;
		params.shelterCountMax = shelterCountMax ? shelterCountMax : -1;
		params.keyword = keyword;		

		Axios.post(apiUrl, params)
			.then(res => {
				if (res.data.Result) {
					const data = res.data.Result;
					if (selectedTown && !isVillageShow) {
						selectedTown.villages.forEach(villageItem => {
							const compare = data.map(item => item['village_id'] === villageItem.code);
							villageItem.show = compare.includes(true);
						})
						this.setState({
							isVillageShow: true,
							selectedTown: selectedTown,
						});
					}

					data.map(item => item.active = false);
					this.setState({
						isDataLoading: false,
						sheltersData: {
							county: county,
							town: town,
							village: village,
							data: data
						}
					})
				}
			})
		this.getCsvData(params);
		this.getShelterCount(params);
	}

	getCsvData = params => {
		const {isMemberLogin} = this.state;
		let url  = isMemberLogin ? `${apiHost}/api/ShelterInfo/GetCsvData` : `${apiHost}/api/ShelterInfo/GetCsvDataPublic`;

		Axios.post(url, params).then(res => {
			this.setState({
				csvData: [res.data]
			})
		})
	}

	getShelterCount = params => {
		const { selectedCounty, selectedTown, selectedVillage } = this.state;
		let county = selectedCounty ? selectedCounty.county : '';
		let town = selectedTown ? selectedTown.town : '';
		Axios.post(`${apiHost}/api/ShelterInfo/GetShelterCount`,params).then(res => {
			this.setState({
				shelterMapData: {
					unit: '次數',
					transferValue: 'Value',
					county: county,
					town: town,
					data: res.data
				}
			})
		})
	}


	handleClickListMarkShelter = (e) => {
		const { sheltersData } = this.state;
		const index = e.currentTarget.dataset.index;
		sheltersData.data.forEach(item => item.active = false);
		sheltersData.data[index].active = true;
		sheltersData.isSelected = true;
		this.setState({ isShelterMark: false, sheltersData: sheltersData });
	}
	handleClickPinMarkShelter = (shelter) => {
		const { sheltersData, csvData } = this.state;
		sheltersData.data.forEach(item => item.active = false);
		sheltersData.data.filter(d => d.shelter_id == shelter.shelter_id)[0].active = true;
		
		var shelter_id_index = csvData[0].table[0].indexOf('災民收容所編號')
		console.log("test:",csvData[0].table)
		var index = csvData[0].table.map(cell => cell.map(cell => cell.trim())).findIndex(d => d[shelter_id_index] == shelter.shelter_id);
		
		this.setState({ isShelterMark: false, sheltersData: sheltersData, activeIndex: index });
	}
	handleDisasterSelected = selectedCode => {
		const { disasterList } = this.state;
		const selectedDisaster = disasterList.find(item => item.Name === selectedCode);
		this.setState({ disaster: selectedDisaster });
	}
	handleFeatureSelected = selectedCode => {
		const { shelterFeatureList } = this.state;
		const selectedFeature = shelterFeatureList.find(item => item.Name === selectedCode);
		this.setState({ feature: selectedFeature });
	}

	handleFeature2Selected = selectedCode => {
		this.setState({ feature2: selectedCode });
	}

	handleShelterCountMin = value => {
		this.setState({ shelterCountMin: value });
	}
	handleShelterCountMax = value => {
		this.setState({ shelterCountMax: value });
	}

	//單筆新增
	handleSingleShelter = () => {
		window.location.href = '/evaluation/evacuation/shelter/-1';
	}
	//單筆修改
	handleSingleEditShelter = () => {
		this.setState({ isEditMode: true })
	}

	//批次新增
	handleBatchShelter = () => {
		window.location.href = '/evaluation/evacuation/shelter/-2';
	}

	handleClickDownloadCSV = () => {
		const { csvData } = this.state;
		let csv = '';
		csvData.forEach((item) => {
			csv = csv + '\n' + item.csv;
		});
		
		csv = csv.replaceAll('<br>','');

		const fileName = `原始資料`;
		const copyright = '\n資料來源：國家災害防救科技中心減災動資料。';
		const csvContent = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURIComponent(csv) + copyright;
		downloadTrigger(fileName + '.csv', csvContent);
	}

	handleClickDownloadXLS = () => {

	}

	handlePinClick = (shelter_id) => {
		const { sheltersData } = this.state;
		sheltersData.data.forEach(item => item.active = false);
		sheltersData.data.filter(d => d.shelter_id == shelter_id)[0].active = true;
		sheltersData.isSelected = true;
		this.setState({ isShelterMark: false, sheltersData: sheltersData });
	}

	handleEditClick = (shelter_id) => {
		window.location.href = '/evaluation/evacuation/shelter/edit/' + shelter_id;
	}

	handleCloseBubble = () => {
		this.setState({ isShelterMark: false });
	}

	handleClickDownloadPNG = () => {
		const captureArea = document.querySelectorAll('.capture');
		const fileName = '收容所地圖';
		chartCapture(captureArea, fileName);
		gaTracking('收容所', '收容所資訊查詢', '圖表下載');
	}
	// handleClickDownloadTextPNG = () => {
    // const captureArea = document.querySelectorAll('.captureText');
	
    // const fileName = '收容所地圖含數值';
    // chartCapture(captureArea, fileName);
    // gaTracking('收容所', '收容所資訊查詢', '圖表下載含數值');
	// }

	render() {
		const { countiesTownsVillagesData, disasterList, shelterFeatureList, disaster, feature, feature2, csvData, isEditMode, activeIndex } = this.state;
		const { isMemberLogin, isDataLoading, isShelterMark } = this.state;
		const { selectedCounty, selectedTown, selectedVillage, sheltersData } = this.state;
		const { updateDate } = this.state;
		const { shelterMapData } = this.state;
		return (
			<React.Fragment>
				<Helmet>
					<title>減災動資料 - 撤離與收容評估</title>
				</Helmet>
				<LimitMask prevPage="/evaluation/evacuation" />
				<div className="evacuation-page">
					<div className="container">
						<div className="evacuation-chart-title">
							<div className="title">收容所資訊查詢</div>
						</div>
						<div className="page-link">
							<Link className="item" to="/evaluation/evacuation/evacuate">
								<span>歷史撤離人次查詢</span>
							</Link>
							<Link className="item" to="/evaluation/evacuation/contain">
								<span>歷史收容人次查詢</span>
							</Link>
							<Link className="item" to="/evaluation/evacuation/alert">
								<span>歷史警戒熱區查詢</span>
							</Link>
							<Link className="item" to="/evaluation/evacuation/estimate">
								<span>撤離與收容人數及物資估計</span>
							</Link>
						</div>
						<section className="shelter-section">
							<div className="controller-bar">
								<div className="controller">
									<div className="step">
										<span>選擇查詢的地區</span>
									</div>

									<div className="select">
										<CustomSelect status="normal" name="county"
											value={selectedCounty ? selectedCounty.code : ''}
											onChange={(value) => { this.handleCountyDistrictPickSelected(value) }}>
											<option key="-1" value="-1">請選擇</option>
											{
												countiesTownsVillagesData &&
												countiesTownsVillagesData.counties.map((item, index) =>
													<option key={item.code} value={item.code}>{item.county}</option>
												)
											}
										</CustomSelect>
									</div>
									<div className="select">
										<CustomSelect status="normal" name="town"
											value={selectedTown ? selectedTown.code : ''}
											onChange={value => this.handleTownDistrictPickSelected(value)}>
											<option key="0" value="0">鄉鎮全選</option>
											{
												selectedCounty &&
												selectedCounty.towns.map((item, index) =>
													<option key={item.code} value={item.code}>{item.town}</option>
												)
											}
										</CustomSelect>
									</div>
									{
										<div className="select">
											<CustomSelect status="normal" name="village"
												value={selectedVillage ? selectedVillage.code : ''}
												onChange={value => this.handleVillageDistrictPickSelected(value)}>
												<option key="0" value="0">村里全選</option>
												{
													selectedTown &&
													selectedTown.villages.map((item, index) =>
														<option key={item.code} value={item.code}>{item.village}</option>
													)
												}
											</CustomSelect>
										</div>
									}
								</div>								
								{/* <div className="controller">
									<div className="step"><span>災別</span></div>
									<div className="select">
										<CustomSelect name='disaster'
											value={disaster ? disaster.Name : ''}
											onChange={value => this.handleDisasterSelected(value)}>
											<option key='0' value="all">災別全選</option>
											{disasterList && disasterList.map(item => <option key={item.Name} value={item.Name}>{item.Name}</option>)}
										</CustomSelect>
									</div>
								</div> */}
								<div className="controller">
									<div className="step hstack-between">
										<span>災別</span>
										<button className='link' onClick={()=>{this.handleDisasterListAll()}}>全選</button>
									</div>
									<div className="select evacuation">
										<div className='custom-select'>
											<div className='wrap -normal'>
												<TagPicker 
													data={this.state.disasterListTagPicker} 
													value={this.state.selectedDisasterList}
													onChange={value => this.handleDisasterListChange(value)}
													placeholder='請選擇'
													block
													searchable={false}
												/>
											</div>
										</div>
									</div>
								</div>
								<div className="controller">
									<div className="step"><span>適合避難弱者安置</span></div>
									<div className="select">
										<CustomSelect name='feature2'
											value={feature2 ? feature2 : ''}
											onChange={value => this.handleFeature2Selected(value)}>
											<option value="all">全選</option>
											<option value='1'>是</option>
											<option value='0'>否</option>
										</CustomSelect>
									</div>
								</div>
								<div className="controller">
									<div className="step"><span>空間特性</span></div>
									<div className="select">
										<CustomSelect name='feature'
											value={feature ? feature.Name : ''}
											onChange={value => this.handleFeatureSelected(value)}>
											<option key='0' value="all">全選</option>
											{shelterFeatureList && shelterFeatureList.map(item => <option key={item.Name} value={item.Name}>{item.Name}</option>)}
										</CustomSelect>
									</div>
								</div>
								{/* <div className="controller">
									<div className="step"><span>收容人數(選填)</span></div>
									<div style={{ fontSize: '14px', lineHeight: '1.5', marginBottom: '10px' }}>
										*根據室內、室外或全選的選項關聯
									</div>
									<div className="anount-wrap">
										<div className="select">
											<div className="custom-select">
												<div className="wrap -normal">
													<input type="number" placeholder=""
														onChange={(e) => { this.setState({ shelterCountMin: e.target.value }) }} />
												</div>
											</div>
										</div>
										<div className="select-noboder">~</div>
										<div className="select">
											<div className="custom-select">
												<div className="wrap -normal">
													<input type="number" placeholder=""
														onChange={(e) => { this.setState({ shelterCountMax: e.target.value }) }}
													/>
												</div>
											</div>
										</div>
									</div>
								</div> */}
								<div className="controller">
									<div className="step"><span>關鍵字(選填)</span></div>
									<div className="select">
										<div className="custom-select">
											<div className="wrap -normal">
												<input type="text" placeholder="收容所名稱/聯絡人姓名/管理人姓名"
													onChange={(e) => { this.setState({ keyword: e.target.value }) }}
													 />
											</div>
										</div>
									</div>
								</div>

								<div className="submit">
									<button
										onClick={this.handleGetShelterLocate} disabled={selectedCounty===null || selectedCounty ===undefined}>確定</button>
								</div>
							</div>
							<div className="shelter-result">
								{isDataLoading && <LoadingDots theme="red" />}
								<div className={`result ${sheltersData ? '-show' : '-hide'}`}>
									<div className="map capture" id='anchor' >
										<div className="title">收容所地圖
										<div style={{float:'right'}} data-html2canvas-ignore >
											<CustomDropdown title="下載" >
												<li><button onClick={this.handleClickDownloadPNG}>下載PNG</button></li>
												{/* <li><button onClick={this.handleClickDownloadTextPNG}>下載PNG(含數值)</button></li> */}
											</CustomDropdown>
										</div>
										</div>
										<SheltertMap
											evacuationData={shelterMapData}
											shelters={sheltersData}
											isMemberLogin={isMemberLogin}
											isShelterMark={isShelterMark}
											handlePinClick={(shelter) => this.handleClickPinMarkShelter(shelter)}
											handleCloseBubble={() => this.handleCloseBubble()}
										/>
									</div>
									{/* 用於下載含數值PNG的地圖
									{shelterMapData && (
										<div style={{position:'absolute', top: '-9999px', left: '-9999px'}}>
											<div>
												<div className="title">收容所地圖</div>
												<EvacuationChartMap evacuationData={shelterMapData} />
											</div>
										</div>
									)} */}
									<hr></hr>

									<div className="origin">
										{sheltersData &&
											<div className='title'>
												<div className="text">查詢結果<span>共 {sheltersData.data.length} 筆</span></div>
												<CustomDropdown title="下載">
													<li><button onClick={this.handleClickDownloadCSV}>下載CSV</button></li>
												</CustomDropdown>
											</div>
										}
										{csvData &&
											<div className="table">
												<ShelterChartTable csvData={csvData} onClick={this.handlePinClick} onEdit={this.handleEditClick} isEditMode={isEditMode} activeIndex={activeIndex} handleSingleEditShelter={this.handleSingleEditShelter} ></ShelterChartTable>
											</div>}
										<p className="remark">*標記為非公開資料；-標記為缺資料/無法計算。如有任何問題請 <a href="/#contact" target="_blank"
											rel="noopener noreferrer">聯絡我們</a></p>
									</div>
									<div className="note capture">
										<p>資料取自衛福部「社政防救災整合平台」資料庫，資料若有疑義，請洽各該地區鄉鎮市區公所，或業務承辦人可於下方按鈕申請異動。</p>
										{
											!isMemberLogin &&
											<p data-html2canvas-ignore>欲查看收容所聯絡方式，請先<button onClick={() => loginRedirect('/evaluation/evacuation/shelter')} href="#">登入會員</button></p>
										}
										{
											updateDate &&
											<p>最後更新時間： {dayjs(updateDate).format('YYYY-MM-DD')}</p>
										}
									</div>
									<div className="shelter-databtn-box">
										<input type='button' className='btn' value='單筆新增申請' onClick={() => this.handleSingleShelter()} ></input>										
										<input type='button' className='btn' value='批次新增/修改申請' onClick={() => this.handleBatchShelter()} ></input>
									</div>
								</div>
							</div>
						</section>

					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default EvacuationShelter;
